module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/aneck4-51bf8ff9384cea4854059f7324b78259.jpg";